import React from "react";
import clsx from "clsx";

export interface SplitEvenlyButtonProps {
  onClick: () => void;
  canSplit: boolean;
  isVisible: boolean;
}

export const SplitEvenlyButton: React.FC<SplitEvenlyButtonProps> = props => {
  if (!props.isVisible) {
    return null;
  }
  return (
    <div
      data-testid="split-evenly-button"
      className={"split-evenly-button-container d-flex justify-content-end text-end"}
      style={{ width: "140px", paddingTop: "4px", fontSize: "14px" }}
    >
      <div
        className={clsx(
          "text-green",
          props.canSplit && "pointer",
          "m-0",
          "justify-content-center",
          "d-inline-block"
        )}
        onClick={() => {
          if (props.canSplit) {
            props.onClick();
          }
        }}
        style={{ opacity: props.canSplit ? "1" : "0.5", width: "120px" }}
      >
        % Split Evenly
      </div>
    </div>
  );
};
